import React from 'react';
import cleanAll from '../../../services/serviceWorker/cleanAll';
import { capture } from '../../../services/sentry/capture';
import { TopBarView } from './TopBar.view';
import usePublicShop from '../../../hooks/usePublicShop';
import Notifications from 'components/organisms/Notifications';
import useGoToPage from '../../../hooks/useGoToPage';
import pages from '../../../routes/pages';
import { refreshPage } from 'helpers/page/refreshPage';

export type Emoji = {
  url: string;
  alt: string;
};

interface TopBarProps {
  title: string;
  onDashboard?: boolean;
  emoji?: Emoji;
  variant: 'default' | 'autumn' | 'spring';
  hideLogOut?: boolean;
}

export const TopBar = ({
  title,
  onDashboard = false,
  emoji = null,
  variant = 'spring',
  hideLogOut
}: TopBarProps) => {
  const { isPublicShop, shopId, classeId } = usePublicShop();
  const goToPublicPanier = useGoToPage(pages.PUBLIC_SHOP_PANIER.path, {
    shopId: shopId,
    classeId: classeId
  });
  const goToPublicShopHome = useGoToPage(pages.PUBLIC_SHOP_HOME.path, {
    shopId: shopId,
    classeId: classeId
  });

  const reload = async () => {
    try {
      await cleanAll();
      refreshPage();
    } catch (e) {
      capture(new Error('Reload page Error'), [e]);
      refreshPage();
    }
  };

  return (
    <TopBarView
      title={title}
      variant={variant}
      emoji={emoji}
      hideLogOut={hideLogOut}
      onDashboard={onDashboard}
      reload={reload}
      notifications={<Notifications />}
      isPublicShop={isPublicShop}
      goToPublicPanier={goToPublicPanier}
      goToPublicShopHome={goToPublicShopHome}
    />
  );
};
